module.exports = __webpack_public_path__ + "static/media/ncbm.634fd613.pdf";